/**
 * Apartsales — Tab 3 (AI-консьерж).
 *
 * Phase 1 spec: docs/architecture/25 §5 + 30-ai-concierge-detailed.md.
 * Chat-first discovery: «Найди мне 2-комнатную в Сочи до 15M с yield > 10%».
 *
 * For now: placeholder explaining what will be here.
 */

import { createFileRoute } from '@tanstack/react-router';
import { TabStub } from '~/components/TabStub';

export const Route = createFileRoute('/ai')({
  component: AIPage,
});

function AIPage() {
  return (
    <TabStub
      title="AI-консьерж"
      subtitle="Chat-first discovery"
      description="Опишите что ищете в свободной форме — AI подберёт 5 лучших вариантов с обоснованием по критериям и Apartsales Score™. Поддерживает голос, фото, ссылки. В разработке."
      docRef="docs/architecture/30"
    />
  );
}
